/*global payhere*/
import React from "react";
import { useNavigate } from "react-router-dom";
import { PAYHERE_RECURRING_ENABLED } from "../../config/payhere";

const PaymentButton = ({ formData }) => {
  const navigate = useNavigate();
  const monthlyPrice = parseFloat(formData?.monthlyPrice ?? formData?.price ?? 0);
  const pendingMonths = Number(formData?.pendingMonths ?? 0);
  const billingMonths = pendingMonths > 0 ? pendingMonths : 1;
  const oneTimeTotal = (monthlyPrice * billingMonths).toFixed(2);
  const startupFee =
    pendingMonths > 1
      ? (monthlyPrice * (pendingMonths - 1)).toFixed(2)
      : undefined;

  const paymentDetails = {
    order_id: formData?.orderId,
    amount: PAYHERE_RECURRING_ENABLED
      ? monthlyPrice.toFixed(2)
      : oneTimeTotal,
    currency: "LKR",
    first_name: formData?.firstName,
    last_name: formData?.lastName,
    email: formData?.email,
    phone: formData?.phone,
    address: formData?.address,
    clinicid: formData?.clinicid,
    startDate: formData?.startDate,
    pendingMonths,
    billingMonths,
    city: "Colombo",
    country: "Sri Lanka",
  };

  const handlePayment = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API}/client/payhere/start`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(paymentDetails),
        }
      );

      if (response.ok) {
        const { hash, merchant_id } = await response.json();
        const payment = {
          merchant_id: merchant_id,
          return_url: undefined,
          cancel_url: undefined,
          notify_url: `${process.env.REACT_APP_API}/client/payhere/notify`,
          order_id: paymentDetails.order_id,
          items: "Care32 Dent Monthly Subscription",
          amount: paymentDetails.amount,
          currency: paymentDetails.currency,
          first_name: paymentDetails.first_name,
          last_name: paymentDetails.last_name,
          email: paymentDetails.email,
          phone: paymentDetails.phone,
          address: paymentDetails.address,
          city: paymentDetails.city,
          country: paymentDetails.country,
          hash: hash,
          custom_1: paymentDetails.clinicid,
          custom_2: PAYHERE_RECURRING_ENABLED
            ? `${paymentDetails.startDate}%1%${paymentDetails.pendingMonths}`
            : `${paymentDetails.startDate}%${paymentDetails.billingMonths}`,
        };

        if (PAYHERE_RECURRING_ENABLED) {
          payment.recurrence = "1 Month";
          payment.duration = "Forever";
          if (startupFee) {
            payment.startup_fee = startupFee;
          }
        }

        payhere.startPayment(payment);

        payhere.onCompleted = function onCompleted(orderId) {
          navigate("/client/payment/success");
        };
        payhere.onDismissed = function onDismissed() {
          navigate("/client/payment/cancel");
        };

        payhere.onError = function onError(error) {
          const message = String(error || "");
          if (message.toLowerCase().includes("token")) {
            navigate("/client/payment/error?reason=token");
            return;
          }
          navigate("/client/payment/error");
        };
      } else {
        console.error("Failed to generate hash for payment.");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  return (
    <button
      onClick={handlePayment}
      className="flex items-center gap-1.5 px-3 py-1.5 text-white bg-gradient-to-r from-primary to-primaryLight rounded-lg font-semibold hover:shadow-lg transition-all duration-200 shadow-md text-xs h-[32px]"
    >
      {PAYHERE_RECURRING_ENABLED ? "Subscribe" : "Pay now"}
    </button>
  );
};

export default PaymentButton;
